class ProductCardForm {
  constructor() {
    this.addVariantToCart();
  }

  addVariantToCart() {
    let hasVariantButtonsWrappers = document.querySelectorAll('.has-variant-btns');
    if (hasVariantButtonsWrappers) {
      hasVariantButtonsWrappers.forEach(wrapper => {
        wrapper.classList.remove('mobile--active');
        const productVariants = wrapper.querySelector('.product-info--variants'); 
        const productVariantMobileButtons = wrapper.querySelector('.product-info--variants--trigger');
        if (productVariants) {
          const form = productVariants.querySelector('form.shopify-product-form');
          const hiddenSubmitButton = productVariants.querySelector('.product-info--form-submit');
          if (form) {
            let inputs = form.querySelectorAll('input[type=radio]');
            if (inputs && inputs.length > 1) {
              inputs.forEach((input, index) => {
                if (index === 0) {
                  input.addEventListener('click', () => {form.requestSubmit(hiddenSubmitButton)});
                } else {
                  input.addEventListener('change', () => {form.requestSubmit(hiddenSubmitButton)});
                }
              });
            } else {
              inputs.forEach(input => {
                input.addEventListener('click', () => {
                  form.requestSubmit(hiddenSubmitButton);          
                });
              });
            }
          }
        }
        if (productVariantMobileButtons) {
          productVariantMobileButtons.addEventListener("touchstart", (event) => {
            const parentWrapper = event.currentTarget.closest('.has-variant-btns');
            hasVariantButtonsWrappers.forEach(wrapper => {
              wrapper.classList.remove('mobile--active');
            });
            if (parentWrapper) {
              parentWrapper.classList.add('mobile--active');
            }
          });
        }
      });
    }
  }
}

export default ProductCardForm;